export const MEDICATION_PLAN_KDL_CODE = 'ED110103'
export const MEDICATION_PLAN_FILE_NAME = 'medication_plan.xml'
